import React from 'react';
import MaleIcon from '../MaleIcon'
import FemaleIcon from '../FemaleIcon'
import ProAMIcon from '../ProAMIcon';
import PairIcon from '../PairIcon';
import Icofont from 'react-icofont';
import { Tooltip } from 'antd';


export function BasedOnGender(props) {
    const { item, number, fontSize, iconWrapperStyle, nameStyle, lined } = props;
    return (<React.Fragment>
        {(item?.genderID === 1 /* Мужчина */) && <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <MaleIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center", ...nameStyle }}>
                {!lined && <span>{item?.lastname + " " + item?.firstname}</span>}
                {!!lined && <div>
                    <div>{item?.lastname}</div>
                    <div>{item?.firstname}</div>
                </div>}
            </div>
        </div>}
        {(item?.genderID === 2 /* Женщина */) && <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <FemaleIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center", ...nameStyle }}>
                {!lined && <span>{item?.lastname + " " + item?.firstname}</span>}
                {!!lined && <div>
                    <div>{item?.lastname}</div>
                    <div>{item?.firstname}</div>
                </div>}
            </div>
        </div>}
    </React.Fragment>)
}
export function ProAM(props) {
    const { item, number, fontSize, iconWrapperStyle, text, lined } = props;
    return (<React.Fragment>
        <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <ProAMIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"}
                        color={(item?.user?.genderID === 1) ? "blue" : "red"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center" }}>
                <div>{item?.user?.lastname + " " + item?.user?.firstname}</div>
                {(item?.partner) && <div style={{ color: "rgba(0,0,0,.65)", fontSize: "12px", fontStyle: "italic" }}>{item?.partner?.lastname + " " + item?.partner?.firstname}</div>}
                {(!item?.partner) && <div style={{ color: "red" }}>{text}</div>}
            </div>
        </div>
    </React.Fragment>)
}
export function Pair(props) {
    const { item, number, fontSize, iconWrapperStyle, text, lined } = props;
    return (<React.Fragment>
        <div style={{ display: "flex", alignItems: "stretch" }}>
            <div className="icon-wrapper" style={{ flex: "0 0 auto", display: "flex", ...iconWrapperStyle }}>
                <div style={{ alignSelf: "center" }}>
                    <PairIcon title={(number) ? number : undefined} fontSize={fontSize || "12px"} />
                </div>
            </div>
            <div style={{ flex: "1 1 auto", alignSelf: "center" }}>
                <div>{item?.user?.lastname + " " + item?.user?.firstname}</div>
                {(item?.partner) && <div>{item?.partner?.lastname + " " + item?.partner?.firstname}</div>}
                {(!item?.partner) && <div style={{ color: "red" }}>{text}</div>}
            </div>
        </div>
    </React.Fragment>)
}


export function Dancer(props) {
    const { item, number, selected, style, className, onClick, fontSize, iconWrapperStyle, lined, nameStyle, children } = props;

    // console.log(item);
    // item?.user.genderID    
    // item?.user.lastname                
    // item?.partner
    // item?.partnerID
    // item?.tipTD
    // item?.tipTDID

    return (
        <div onClick={onClick} className={`dancer ${(className) ? className : ""} ${(selected) ? "selected" : ""}`} style={style}>
            {(!item?.tipTDID && !children) && <BasedOnGender item={item?.user} number={number} fontSize={fontSize} iconWrapperStyle={iconWrapperStyle} nameStyle={nameStyle} lined={lined} />}
            {(item?.tipTDID === 1 /* Pro-AM */) && <React.Fragment>
                <ProAM item={item} number={number} text={"Нет ассистента"} fontSize={fontSize} iconWrapperStyle={iconWrapperStyle} lined={lined} />
            </React.Fragment>}
            {(item?.tipTDID === 2 /* Пары */) && <React.Fragment>
                <Pair item={item} number={number} text={"Нет партнера"} fontSize={fontSize} iconWrapperStyle={iconWrapperStyle} lined={lined} />
            </React.Fragment>}
            {children}
        </div>
    )
}

export function UserName({ item, noborder, noicon, number }) {
    return (<>
        <div style={{
            fontWeight: "500", textAlign: "left", textWrap: "nowrap",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    {(!noicon && item?.genderID) && <span>
                        {/* {(item?.genderID == 1) ? <MaleIcon title={(number) ? number : undefined} /> : <FemaleIcon title={(number) ? number : undefined} />} */}
                        {(item?.genderID == 1) ? <span>
                            <Icofont icon={"businessman"} style={{ color: "blue", fontSize: "14px", paddingRight: "4px" }} />
                            {number && <span style={{
                                padding: "1px 5px",
                                marginRight: "4px",
                                backgroundColor: "#e3e3e3",
                                borderRadius: "4px"
                            }}>{number}</span>}
                        </span> : <span>
                            <Icofont icon={"businesswoman"} style={{ color: "red", fontSize: "14px", paddingRight: "4px" }} />
                            {number && <span style={{
                                padding: "1px 5px",
                                marginRight: "4px",
                                backgroundColor: "#e3e3e3",
                                borderRadius: "4px"
                            }}>{number}</span>}
                        </span>}
                    </span>}
                    {item?.lastname} {item?.firstname}
                    {/* от {dayjs(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss")} */}
                </div>
                {!noborder && <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>}
            </div>
        </div>
    </>)
}
export function UserName2Line({ item, noborder, noicon, maxWidth, number }) {
    return (<>
        <div style={{
            fontWeight: "500", textAlign: "left", textWrap: "nowrap",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", justifyContent: "start" }}>
                    {(!noicon && item?.genderID) && <div>
                        {(item?.genderID == 1) ? <span>
                            <Icofont icon={"businessman"} style={{ color: "blue", fontSize: "14px", paddingRight: "4px" }} />
                            {number && <span style={{
                                padding: "1px 5px",
                                marginRight: "4px",
                                backgroundColor: "#e3e3e3",
                                borderRadius: "4px"
                            }}>{number}</span>}
                        </span> : <span>
                            <Icofont icon={"businesswoman"} style={{ color: "red", fontSize: "14px", paddingRight: "4px" }} />
                            {number && <span style={{
                                padding: "1px 5px",
                                marginRight: "4px",
                                backgroundColor: "#e3e3e3",
                                borderRadius: "4px"
                            }}>{number}</span>}
                        </span>}
                    </div>}
                    <div>
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: maxWidth || "100px" }}>{item?.lastname}</div>
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: maxWidth || "100px" }}>{item?.firstname}</div>
                    </div>
                    {/* от {dayjs(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss")} */}
                </div>
                {!noborder && <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>}
            </div>
        </div>
    </>)
}

export default function User({ item, noborder, noicon, extend }) {
    return (<>
        <div style={{
            fontWeight: "500", textAlign: "left", textWrap: "nowrap",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    {(!noicon && item.genderID) && <span>
                        {(item.genderID == 1) ? <MaleIcon /> : <FemaleIcon />}
                    </span>}
                    {item.lastname} {item.firstname} {item.patronymic}
                    {/* от {dayjs(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss")} */}
                </div>
                {!noborder && <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>}
            </div>
        </div>
        {(item.email || item.phone) &&
            <div style={{
                fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }}>

                {(item.email) && <Tooltip title={<span><Icofont icon="mail" /> {item.email}</span>}><span><Icofont icon="mail" /> {item.email}</span></Tooltip>}
                {(item.phone) && <Tooltip title={<span style={{ paddingLeft: "5px" }}><Icofont icon="phone" />+{item.phone}</span>}><span style={{ paddingLeft: "5px" }}><Icofont icon="phone" />+{item.phone}</span></Tooltip>}
            </div>
        }
    </>)
}